var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowercase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "rtl-flip-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 113.778v-113.778h796.445v113.778h-341.334v910.222h-113.777v-910.222h-341.334zM568.889 568.889v-113.778h455.111v113.778h-170.664v455.111h-113.781v-455.111h-170.666z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowercase);
export default __webpack_public_path__ + "static/media/lowercase.e84a41bbe1d8c80106f64030725fdfbd.svg";
export { ForwardRef as ReactComponent };